import * as types from "./types";
import { StorageService } from "./../../services";

export const setAuth = (authData) => {
  return {
    type: types.SET_AUTH,
    payload: authData,
  };
};

export const clearAuthAndLogout = () => {
  StorageService.removeAll();
  return {
    type: types.CLEAR_AUTH,
  };
};

export const setUser = (userData) => {
  return {
    type: types.SET_USER,
    payload: {
      data: userData?.data,
      token: userData?.authorization,
      currentRole: userData?.currentRole,
    },
  };
};
